"use strict";
exports.__esModule = true;
exports.fetchLatestUpdate = void 0;
var t = require("io-ts");
var createReqRes_1 = require("../request-handler/createReqRes");
var basic_1 = require("./util/basic");
// Origination FROM web
exports.fetchLatestUpdate = (0, createReqRes_1.createReqRes)('fetchLatestUpdate', t.type({}), basic_1.genericStatusMessage);
//# sourceMappingURL=developer-tools.js.map